// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3286":"59d8ff14","4099":"7873b1eb","4314":"59d8ff14","9306":"59d8ff14","9535":"59d8ff14"}[chunkId] + ".chunk.css";
};